"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NavigationRightCircle1Alternate1: ['navigation-right-circle-1-alternate-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24Zm0-2A10,10,0,1,1,22,12,10.012,10.012,0,0,1,12,22Z', 'M12.115,15.616l1.939-1.94a.25.25,0,0,0-.177-.426H6a1.25,1.25,0,0,1,0-2.5h7.879a.25.25,0,0,0,.177-.427l-1.939-1.94a1.249,1.249,0,0,1,1.767-1.767l4.5,4.5a1.249,1.249,0,0,1,0,1.767l-4.5,4.5a1.249,1.249,0,0,1-1.767-1.767Z']],
  NavigationDownCircleAlternate: ['navigation-down-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.012,10.012,0,0,1,12,22Z', 'M15.615,12.116l-1.94,1.939a.25.25,0,0,1-.427-.177V6a1.25,1.25,0,1,0-2.5,0v7.878a.25.25,0,0,1-.426.177l-1.94-1.939a1.249,1.249,0,0,0-1.767,1.767l4.5,4.5a1.247,1.247,0,0,0,1.767,0l4.5-4.5a1.249,1.249,0,0,0-1.767-1.767Z']],
  NavigationLeftCircle1Alternate: ['navigation-left-circle-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M15.5,9.5h-5.25a.25.25,0,0,1-.25-.25V8A1,1,0,0,0,8.29,7.3l-3,3a1,1,0,0,0,0,1.414l3,3A1,1,0,0,0,10,14v-1.25a.25.25,0,0,1,.25-.25H15.5a1,1,0,0,1,0,2,1.5,1.5,0,0,0,0,3,4,4,0,1,0,0-8Z']],
  NavigationLeftCircle2Alternate: ['navigation-left-circle-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12A12,12,0,1,0,12,0,12.014,12.014,0,0,0,0,12Zm2,0A10,10,0,1,1,12,22,10.011,10.011,0,0,1,2,12Z', 'M4.393,10.9l4-4a.5.5,0,0,1,.853.354v1.5A.25.25,0,0,0,9.5,9h5.75a3.99,3.99,0,0,1,.407,7.961.5.5,0,0,1-.151-.987,1.25,1.25,0,0,0-.256-2.474H9.5a.25.25,0,0,0-.25.25v1.5a.5.5,0,0,1-.853.353l-4-4A.5.5,0,0,1,4.393,10.9Z']],
  NavigationNextAlternate: ['navigation-next-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.7,10.209a1,1,0,0,0,0-1.414L20.2,5.3A1,1,0,0,0,18.5,6v1.75a.249.249,0,0,1-.25.25H12.5a4.005,4.005,0,0,0-4,4v2a1.5,1.5,0,0,0,3,0V12a1,1,0,0,1,1-1h5.75a.249.249,0,0,1,.25.25V13a1,1,0,0,0,1.708.707Z', 'M16,12.5a1,1,0,0,0-1,1V18a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,18V6a.5.5,0,0,1,.5-.5H15a1,1,0,1,0,2,0,2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2v-5A1,1,0,0,0,16,12.5Z']],
  NavigationLeftCircle1Alternate1: ['navigation-left-circle-1-alternate-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,2A10,10,0,1,1,2,12,10.011,10.011,0,0,1,12,2Z', 'M11.882,8.383l-1.939,1.94a.25.25,0,0,0,.177.427H18a1.25,1.25,0,0,1,0,2.5H10.12a.25.25,0,0,0-.177.426l1.939,1.94a1.249,1.249,0,0,1-1.767,1.767l-4.5-4.5a1.247,1.247,0,0,1,0-1.767l4.5-4.5a1.249,1.249,0,0,1,1.767,1.767Z']],
  NavigationPreviousAlternate: ['navigation-previous-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.289,10.209a1,1,0,0,1,0-1.414l3.5-3.5A1,1,0,0,1,5.5,6v1.75a.25.25,0,0,0,.25.25H11.5a4,4,0,0,1,4,4v2a1.5,1.5,0,0,1-3,0V12a1,1,0,0,0-1-1H5.746a.25.25,0,0,0-.25.25V13a1,1,0,0,1-1.707.707Z', 'M8,12.5a1,1,0,0,1,1,1V18a.5.5,0,0,0,.5.5h12A.5.5,0,0,0,22,18V6a.5.5,0,0,0-.5-.5H9a1,1,0,1,1-2,0,2,2,0,0,1,2-2H22a2,2,0,0,1,2,2v13a2,2,0,0,1-2,2H9a2,2,0,0,1-2-2v-5A1,1,0,0,1,8,12.5Z']],
  NavigationArrowsDown: ['navigation-arrows-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.709,13.085h-1.4a.5.5,0,0,0-.337.13l-6.964,6.333a1.494,1.494,0,0,1-2.018,0L4.025,13.215a.5.5,0,0,0-.336-.13h-1.4a.986.986,0,0,0-.921.626.975.975,0,0,0,.254,1.114l9.693,8.814a.99.99,0,0,0,.679.271,1.019,1.019,0,0,0,.681-.264l9.692-8.814a.971.971,0,0,0,.271-1.1A.994.994,0,0,0,21.709,13.085Z', 'M11.315,17.139a.99.99,0,0,0,.679.271,1.019,1.019,0,0,0,.681-.264l9.692-8.814a.971.971,0,0,0,.271-1.1.994.994,0,0,0-.929-.648h-1.4a.5.5,0,0,0-.337.13l-6.964,6.333a1.494,1.494,0,0,1-2.018,0L4.025,6.715a.5.5,0,0,0-.336-.13h-1.4a.986.986,0,0,0-.921.626.975.975,0,0,0,.254,1.114Z', 'M11.325,10.649a1,1,0,0,0,1.345,0l9.707-8.823a1,1,0,0,0-.672-1.74H2.292a1,1,0,0,0-.673,1.739Z']],
  NavigationUPCircleAlternate: ['navigation-up-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12A12,12,0,1,0,12,24,12.013,12.013,0,0,0,24,12Zm-2,0A10,10,0,1,1,12,2,10.011,10.011,0,0,1,22,12Z', 'M15.615,11.883l-1.94-1.939a.25.25,0,0,0-.427.177V18a1.25,1.25,0,0,1-2.5,0V10.121a.25.25,0,0,0-.426-.177l-1.94,1.939a1.249,1.249,0,0,1-1.767-1.767l4.5-4.5a1.249,1.249,0,0,1,1.767,0l4.5,4.5a1.249,1.249,0,0,1-1.767,1.767Z']],
  NavigationArrowsLeft1: ['navigation-arrows-left-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.31,21.969V20.5a.751.751,0,0,0-.278-.583L6.453,12.969a1.288,1.288,0,0,1,0-1.943L15.032,4.08A.75.75,0,0,0,15.31,3.5V2.026a1.25,1.25,0,0,0-2.022-.983L.6,11.014a1.289,1.289,0,0,0,0,1.966l12.691,9.972a1.25,1.25,0,0,0,2.022-.983Z', 'M9.145,11.014a1.289,1.289,0,0,0,0,1.966l12.692,9.972a1.249,1.249,0,0,0,2.021-.983V2.026a1.249,1.249,0,0,0-2.021-.983Z']],
  NavigationRightCircle2Alternate: ['navigation-right-circle-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M19.6,10.9l-4-4a.5.5,0,0,0-.854.354v1.5A.249.249,0,0,1,14.5,9H8.746a3.99,3.99,0,0,0-.406,7.961.5.5,0,0,0,.151-.987A1.25,1.25,0,0,1,8.746,13.5H14.5a.249.249,0,0,1,.25.25v1.5a.5.5,0,0,0,.854.353l4-4A.5.5,0,0,0,19.6,10.9Z']],
  NavigationDown2: ['navigation-down-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.93,19.32l5.443,4.454a.99.99,0,0,0,1.254,0L18.07,19.32a.989.989,0,0,0-.627-1.755H13.487a.25.25,0,0,1-.25-.25V7.175a.25.25,0,0,1,.25-.25h3.461a1.237,1.237,0,1,0,0-2.474h-9.9a1.237,1.237,0,1,0,0,2.474h3.461a.25.25,0,0,1,.25.25v10.14a.25.25,0,0,1-.25.25H6.557A.989.989,0,0,0,5.93,19.32Z', 'M5.814,1.235A1.237,1.237,0,0,0,7.052,2.472h9.9a1.237,1.237,0,1,0,0-2.474h-9.9A1.237,1.237,0,0,0,5.814,1.235Z']],
  NavigationDown1: ['navigation-down-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.742,12.247a1.441,1.441,0,0,0-2.005-.36L12.274,18.47a.482.482,0,0,1-.548,0L2.263,11.887A1.44,1.44,0,1,0,.618,14.251l9.463,6.583a3.373,3.373,0,0,0,3.838,0l9.463-6.583A1.439,1.439,0,0,0,23.742,12.247Z', 'M.892,7.525l9.464,6.583a2.892,2.892,0,0,0,3.289,0l9.463-6.583a.961.961,0,0,0,.412-.788V3.523a.96.96,0,0,0-1.509-.788L12.548,9.318a.962.962,0,0,1-1.1,0L1.989,2.735A.96.96,0,0,0,.48,3.523V6.737A.961.961,0,0,0,.892,7.525Z']],
  NavigationDownCircle: ['navigation-down-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.207,13.707-4.5,4.5a1,1,0,0,1-1.414,0l-4.5-4.5a1,1,0,0,1,1.414-1.414l2.366,2.366A.25.25,0,0,0,11,14.48V6a1,1,0,0,1,2,0V14.48a.25.25,0,0,0,.427.177l2.366-2.366a1,1,0,0,1,1.414,1.414Z']],
  NavigationLeft1: ['navigation-left-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.4,11.22,8.391,1.233A1.232,1.232,0,0,1,9.774.817,1.245,1.245,0,0,1,10.627,2V3.5a.25.25,0,0,0,.25.25h11.75A1.251,1.251,0,0,1,23.877,5v8.752a.25.25,0,0,1-.25.25h-4a2.5,2.5,0,0,0-2.5,2.5V20a.25.25,0,0,1-.25.25h-6a.25.25,0,0,0-.25.25V22A1.259,1.259,0,0,1,9.37,23.247a1.227,1.227,0,0,1-.972-.475L.412,12.79A1.229,1.229,0,0,1,.4,11.22Z', 'M18.124,16.5a1.5,1.5,0,0,1,1.5-1.5h3.4a.249.249,0,0,1,.168.434c-1.067.974-3.638,3.317-4.649,4.238a.25.25,0,0,1-.418-.185Z']],
  NavigationLeft2: ['navigation-left-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.751,23.739a1.44,1.44,0,0,0,.36-2L5.528,12.272a.48.48,0,0,1,0-.549L12.111,2.26A1.44,1.44,0,0,0,9.746.616L3.164,10.079a3.372,3.372,0,0,0,0,3.837l6.582,9.463A1.44,1.44,0,0,0,11.751,23.739Z', 'M16.473.89,9.889,10.353a2.892,2.892,0,0,0,0,3.289l6.584,9.464a.961.961,0,0,0,.788.411h3.213a.96.96,0,0,0,.788-1.508l-6.583-9.463a.965.965,0,0,1,0-1.1l6.583-9.464A.96.96,0,0,0,20.474.478H17.261A.96.96,0,0,0,16.473.89Z']],
  NavigationLeft3: ['navigation-left-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.776,5.622a.989.989,0,0,0-1.1.306L.224,11.371a.989.989,0,0,0,0,1.254l4.453,5.443a.99.99,0,0,0,1.756-.627V13.485a.25.25,0,0,1,.25-.25H16.822a.25.25,0,0,1,.25.25v3.461a1.237,1.237,0,1,0,2.474,0v-9.9a1.237,1.237,0,1,0-2.474,0v3.462a.25.25,0,0,1-.25.25H6.683a.25.25,0,0,1-.25-.25V6.554A.99.99,0,0,0,5.776,5.622Z', 'M24,7.049a1.237,1.237,0,1,0-2.474,0v9.9a1.237,1.237,0,1,0,2.474,0Z']],
  NavigationLeft4: ['navigation-left-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.75,13.5a.25.25,0,0,0-.25.25V16.5a1,1,0,0,1-1.748.664l-4-4.5a1,1,0,0,1,0-1.329l4-4.5A1,1,0,0,1,14.5,7.5v2.75a.25.25,0,0,0,.25.25h9a.25.25,0,0,0,.25-.25V3a3,3,0,0,0-3-3H12a12,12,0,0,0,0,24h9a3,3,0,0,0,3-3v-7.25a.25.25,0,0,0-.25-.25Z']],
  NavigationDown3: ['navigation-down-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3a3,3,0,0,0-3-3H13.75a.25.25,0,0,0-.25.25v9a.25.25,0,0,0,.25.25H16.5a1,1,0,0,1,.665,1.747l-4.5,4a1,1,0,0,1-1.33,0l-4.5-4A1,1,0,0,1,7.5,9.5h2.75a.25.25,0,0,0,.25-.25v-9A.25.25,0,0,0,10.25,0H3A3,3,0,0,0,0,3v9a12,12,0,0,0,24,0Z']],
  NavigationLeftCircle1: ['navigation-left-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12A12,12,0,1,0,12,24,12.013,12.013,0,0,0,24,12ZM10.293,17.2l-4.5-4.5a1,1,0,0,1,0-1.414l4.5-4.5a1,1,0,1,1,1.414,1.414L9.341,10.571A.25.25,0,0,0,9.518,11H18a1,1,0,0,1,0,2H9.518a.25.25,0,0,0-.177.426l2.366,2.367A1,1,0,0,1,10.293,17.2Z']],
  NavigationNext: ['navigation-next', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.751,11.5a.25.25,0,0,0-.25.25V13.5a2.5,2.5,0,0,1-5,0v-2a5.006,5.006,0,0,1,5-5h4.25a.25.25,0,0,0,.25-.25V5.5a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2v-6.75a.25.25,0,0,0-.25-.25Z', 'M23.708,8.291h0l-3.5-3.5A1,1,0,0,0,18.5,5.5v2.25a.25.25,0,0,1-.25.25H12.5A3.5,3.5,0,0,0,9,11.5v2a1,1,0,0,0,2,0v-2A1.5,1.5,0,0,1,12.5,10h5.75a.25.25,0,0,1,.25.25V12.5a1,1,0,0,0,1.707.707l3.5-3.5h0A1,1,0,0,0,23.708,8.291Z']],
  NavigationPrevious: ['navigation-previous', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.249,11.5a.25.25,0,0,1,.25.25V13.5a2.5,2.5,0,1,0,5,0v-2a5.006,5.006,0,0,0-5-5H7.249A.25.25,0,0,1,7,6.248V5.5a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2v13a2,2,0,0,1-2,2H9a2,2,0,0,1-2-2v-6.75a.25.25,0,0,1,.25-.25Z', 'M.292,8.291h0l3.5-3.5A1,1,0,0,1,5.5,5.5v2.25a.25.25,0,0,0,.25.25H11.5A3.5,3.5,0,0,1,15,11.5v2a1,1,0,0,1-2,0v-2A1.5,1.5,0,0,0,11.5,10H5.749a.25.25,0,0,0-.25.25V12.5a1,1,0,0,1-1.707.707l-3.5-3.5h0A1,1,0,0,1,.292,8.291Z']],
  NavigationRight: ['navigation-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.074,4.963a1.5,1.5,0,0,0-1.632.321L18.436,8.277a.249.249,0,0,1-.289.046C13.2,5.812,8.431,5.529,4.965,7.569,1.763,9.454,0,13.211,0,18.146a1,1,0,0,0,2,0c0-2.373.9-4.112,2.617-5.028,2.115-1.132,5.125-.892,7.971.565a.249.249,0,0,1,.063.4l-2.5,2.5a1.5,1.5,0,0,0,1.061,2.561H23a1,1,0,0,0,1-1V6.349A1.5,1.5,0,0,0,23.074,4.963Z']],
  NavigationRight1: ['navigation-right-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.6,11.22,15.609,1.233A1.232,1.232,0,0,0,14.226.817,1.245,1.245,0,0,0,13.373,2V3.5a.25.25,0,0,1-.25.25H1.373A1.251,1.251,0,0,0,.123,5v8.752a.25.25,0,0,0,.25.25h4a2.5,2.5,0,0,1,2.5,2.5V20a.25.25,0,0,0,.25.25h6a.25.25,0,0,1,.25.25V22a1.259,1.259,0,0,0,1.257,1.248,1.227,1.227,0,0,0,.972-.475l7.986-9.982A1.229,1.229,0,0,0,23.6,11.22Z', 'M5.876,16.5a1.5,1.5,0,0,0-1.5-1.5H.973a.249.249,0,0,0-.168.434c1.067.974,3.638,3.317,4.649,4.238a.25.25,0,0,0,.418-.185Z']],
  NavigationRight2: ['navigation-right-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.249,23.739a1.44,1.44,0,0,1-.36-2l6.583-9.463a.48.48,0,0,0,0-.549L11.889,2.26A1.44,1.44,0,0,1,14.254.616l6.582,9.463a3.372,3.372,0,0,1,0,3.837l-6.582,9.463A1.44,1.44,0,0,1,12.249,23.739Z', 'M7.527.89l6.584,9.463a2.892,2.892,0,0,1,0,3.289L7.527,23.106a.961.961,0,0,1-.788.411H3.526a.96.96,0,0,1-.788-1.508l6.583-9.463a.965.965,0,0,0,0-1.1L2.738,1.986A.96.96,0,0,1,3.526.478H6.739A.96.96,0,0,1,7.527.89Z']],
  NavigationRight3: ['navigation-right-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.237,18.183a1.237,1.237,0,0,0,1.237-1.237v-9.9A1.237,1.237,0,0,0,0,7.049v9.9A1.237,1.237,0,0,0,1.237,18.183Z', 'M5.691,18.183a1.237,1.237,0,0,0,1.237-1.237V13.485a.25.25,0,0,1,.25-.25H17.317a.25.25,0,0,1,.25.25v3.956a.99.99,0,0,0,1.756.627l4.453-5.444a.987.987,0,0,0,0-1.253L19.323,5.927a.99.99,0,0,0-1.756.627V10.76H7.178a.249.249,0,0,1-.25-.25V7.049a1.237,1.237,0,0,0-2.474,0v9.9A1.237,1.237,0,0,0,5.691,18.183Z']],
  NavigationRight4: ['navigation-right-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.25,10.5a.25.25,0,0,0,.25-.25V7.5a1,1,0,0,1,1.748-.665l4,4.5a1,1,0,0,1,0,1.329l-4,4.5A1,1,0,0,1,9.5,16.5v-2.75a.25.25,0,0,0-.25-.25h-9a.25.25,0,0,0-.25.25V21a3,3,0,0,0,3,3h9A12,12,0,0,0,12,0H3A3,3,0,0,0,0,3v7.25a.25.25,0,0,0,.25.25Z']],
  NavigationLeftCircle2: ['navigation-left-circle-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12A12,12,0,1,0,12,0,12.013,12.013,0,0,0,0,12Zm8.4,3.6-4-4a.5.5,0,0,1,0-.707l4-4a.5.5,0,0,1,.854.354v1.5A.25.25,0,0,0,9.5,9h5.75a3.99,3.99,0,0,1,.406,7.961.5.5,0,0,1-.151-.988A1.25,1.25,0,0,0,15.25,13.5H9.5a.25.25,0,0,0-.25.25v1.5A.5.5,0,0,1,8.4,15.6Z']],
  NavigationUp3: ['navigation-up-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,21a3,3,0,0,0,3,3h7.25a.25.25,0,0,0,.25-.25v-9a.25.25,0,0,0-.25-.25H7.5a1,1,0,0,1-.665-1.748l4.5-4a1,1,0,0,1,1.33,0l4.5,4A1,1,0,0,1,16.5,14.5H13.75a.25.25,0,0,0-.25.25v9a.25.25,0,0,0,.25.25H21a3,3,0,0,0,3-3V12A12,12,0,0,0,0,12Z']],
  NavigationUpCircle: ['navigation-up-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM6.793,10.291l4.5-4.5a1,1,0,0,1,1.414,0l4.5,4.5a1,1,0,1,1-1.414,1.414L13.427,9.338A.25.25,0,0,0,13,9.515V18a1,1,0,0,1-2,0V9.515a.25.25,0,0,0-.427-.177L8.207,11.705a1,1,0,1,1-1.414-1.414Z']],
  NavigationUp2: ['navigation-up-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.93,4.675a.99.99,0,0,0,.627,1.756h3.956a.25.25,0,0,1,.25.25V16.82a.25.25,0,0,1-.25.25H7.052a1.237,1.237,0,1,0,0,2.474h9.9a1.237,1.237,0,1,0,0-2.474H13.487a.25.25,0,0,1-.25-.25V6.681a.25.25,0,0,1,.25-.25h3.956a.99.99,0,0,0,.627-1.756L12.627.222a.989.989,0,0,0-1.254,0Z', 'M16.948,21.523h-9.9a1.238,1.238,0,1,0,0,2.475h9.9a1.238,1.238,0,1,0,0-2.475Z']],
  NavigationRightCircle2: ['navigation-right-circle-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM15.059,15.71a.5.5,0,0,1-.309-.462v-1.5a.25.25,0,0,0-.25-.25H8.75a1.25,1.25,0,0,0-.255,2.473.5.5,0,0,1-.151.988A3.99,3.99,0,0,1,8.75,9H14.5a.25.25,0,0,0,.25-.25v-1.5a.5.5,0,0,1,.854-.354l4,4a.5.5,0,0,1,0,.707l-4,4A.5.5,0,0,1,15.059,15.71Z']],
  NavigationRightCircle1: ['navigation-right-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12A12,12,0,1,0,12,0,12.014,12.014,0,0,0,0,12ZM13.707,6.791l4.5,4.5a1,1,0,0,1,0,1.414l-4.5,4.5a1,1,0,0,1-1.414-1.414l2.366-2.367A.25.25,0,0,0,14.482,13H6a1,1,0,1,1,0-2h8.482a.25.25,0,0,0,.177-.427L12.293,8.205a1,1,0,0,1,1.414-1.414Z']],
  NavigationUp: ['navigation-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.777.4l9.988,7.99A1.25,1.25,0,0,1,22,10.624H20.5a.25.25,0,0,0-.25.25v11.75A1.251,1.251,0,0,1,19,23.874H10.247a.249.249,0,0,1-.25-.25v-4a2.5,2.5,0,0,0-2.5-2.5H4a.25.25,0,0,1-.25-.25v-6a.25.25,0,0,0-.25-.25H2A1.255,1.255,0,0,1,.751,9.368,1.232,1.232,0,0,1,1.225,8.4L11.208.409A1.227,1.227,0,0,1,12.777.4Z', 'M7.5,18.122a1.5,1.5,0,0,1,1.5,1.5v3.4a.251.251,0,0,1-.435.169L4.325,18.544a.25.25,0,0,1,.184-.418Z']],
  NavigationArrowsRight1: ['navigation-arrows-right-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.69,2.027V3.5a.751.751,0,0,0,.278.583l8.579,6.945a1.288,1.288,0,0,1,0,1.943L8.968,19.915a.75.75,0,0,0-.278.583v1.471a1.25,1.25,0,0,0,2.022.983L23.4,12.981a1.289,1.289,0,0,0,0-1.966L10.712,1.043a1.25,1.25,0,0,0-2.022.984Z', 'M14.855,12.981a1.289,1.289,0,0,0,0-1.966L2.163,1.043a1.249,1.249,0,0,0-2.021.984V21.969a1.249,1.249,0,0,0,2.021.983Z']],
  NavigationButtonLeft: ['navigation-button-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.25,6h-10a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1V7A1,1,0,0,0,11.25,6Zm-2,7H6.75a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-.308.462.5.5,0,0,1-.545-.108l-2.5-2.5a.5.5,0,0,1,0-.707l2.5-2.5A.5.5,0,0,1,6.25,9.5v1a.5.5,0,0,0,.5.5h2.5a1,1,0,0,1,0,2Z', 'M21.1,9.144a.5.5,0,0,0-.854.353v1a.5.5,0,0,1-.5.5h-3a1,1,0,0,0,0,2h3a.5.5,0,0,1,.5.5v1a.5.5,0,0,0,.309.462A.489.489,0,0,0,20.75,15a.5.5,0,0,0,.354-.146l2.5-2.5a.5.5,0,0,0,0-.707Z']],
  NavigationButtonRight: ['navigation-button-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.75,6h-10a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1V7A1,1,0,0,0,22.75,6ZM21.1,12.351l-2.5,2.5A.5.5,0,0,1,18.25,15a.508.508,0,0,1-.191-.038.5.5,0,0,1-.309-.462v-1a.5.5,0,0,0-.5-.5h-2.5a1,1,0,0,1,0-2h2.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.309-.462.507.507,0,0,1,.545.108l2.5,2.5A.5.5,0,0,1,21.1,12.351Z', 'M8.25,12a1,1,0,0,0-1-1h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,0-.309-.462.505.505,0,0,0-.545.108l-2.5,2.5a.5.5,0,0,0,0,.707l2.5,2.5A.5.5,0,0,0,3.25,15a.508.508,0,0,0,.191-.038A.5.5,0,0,0,3.75,14.5v-1a.5.5,0,0,1,.5-.5h3A1,1,0,0,0,8.25,12Z']],
  NavigationArrowsUp1: ['navigation-arrows-up-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.029,15.308H3.5a.751.751,0,0,0,.583-.278l6.946-8.58a1.289,1.289,0,0,1,1.942,0l6.946,8.58a.754.754,0,0,0,.583.278h1.471a1.25,1.25,0,0,0,.983-2.023L12.983.6a1.289,1.289,0,0,0-1.966,0L1.046,13.285a1.251,1.251,0,0,0,.983,2.023Z', 'M12.983,9.143a1.288,1.288,0,0,0-1.966,0L1.045,21.834a1.251,1.251,0,0,0,.984,2.022H21.971a1.249,1.249,0,0,0,.983-2.022Z']],
  NavigationLeft: ['navigation-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.035,7.569c-3.466-2.039-8.23-1.757-13.182.754a.251.251,0,0,1-.29-.046L2.557,5.283A1.5,1.5,0,0,0,0,6.348v11.8a1,1,0,0,0,1,1H12.792a1.5,1.5,0,0,0,1.061-2.561l-2.5-2.5a.249.249,0,0,1-.071-.215.252.252,0,0,1,.133-.184c2.847-1.457,5.857-1.7,7.972-.565C21.1,14.034,22,15.773,22,18.146a1,1,0,0,0,2,0C24,13.211,22.237,9.454,19.035,7.569Z']],
  NavigationArrowsDown1: ['navigation-arrows-down-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.971,8.687H20.5a.749.749,0,0,0-.583.279l-6.946,8.579a1.287,1.287,0,0,1-1.942,0L4.083,8.966A.752.752,0,0,0,3.5,8.687H2.029a1.25,1.25,0,0,0-.983,2.023L11.017,23.4a1.288,1.288,0,0,0,1.966,0l9.971-12.69a1.251,1.251,0,0,0-.983-2.023Z', 'M11.017,14.852a1.288,1.288,0,0,0,1.966,0L22.955,2.161A1.251,1.251,0,0,0,21.971.139H2.029a1.25,1.25,0,0,0-.983,2.022Z']],
  NavigationArrowsRight: ['navigation-arrows-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.087,2.289v1.4a.5.5,0,0,0,.13.336l6.333,6.964a1.493,1.493,0,0,1,0,2.019l-6.333,6.965a.5.5,0,0,0-.13.336v1.4a1,1,0,0,0,1.741.666l8.813-9.692a.987.987,0,0,0,.272-.68,1.013,1.013,0,0,0-.265-.68L14.834,1.63a.969.969,0,0,0-1.1-.27A.992.992,0,0,0,13.087,2.289Z', 'M17.141,12.683a.987.987,0,0,0,.272-.68,1.013,1.013,0,0,0-.265-.68L8.334,1.63a.969.969,0,0,0-1.1-.27.992.992,0,0,0-.649.929v1.4a.5.5,0,0,0,.13.336l6.333,6.964a1.493,1.493,0,0,1,0,2.019L6.717,19.973a.5.5,0,0,0-.13.336v1.4a1,1,0,0,0,1.741.666Z', 'M10.652,12.673a1,1,0,0,0,0-1.345L1.828,1.621a1,1,0,0,0-1.741.672V21.706a1,1,0,0,0,1.74.672Z']],
  NavigationRightCircle1Alternate: ['navigation-right-circle-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12A12,12,0,1,0,12,0,12.014,12.014,0,0,0,0,12Zm2,0A10,10,0,1,1,12,22,10.011,10.011,0,0,1,2,12Z', 'M8.5,9.5h5.25a.249.249,0,0,0,.25-.25V8A1,1,0,0,1,15.7,7.3l3,3a1,1,0,0,1,0,1.414l-3,3A1,1,0,0,1,14,14v-1.25a.249.249,0,0,0-.25-.25H8.5a1,1,0,0,0,0,2,1.5,1.5,0,1,1,0,3,4,4,0,0,1,0-8Z']],
  NavigationDown: ['navigation-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.223,23.6l-9.988-7.99A1.25,1.25,0,0,1,2,13.371H3.5a.25.25,0,0,0,.25-.25V1.371A1.251,1.251,0,0,1,5,.121h8.752a.25.25,0,0,1,.25.25v4a2.5,2.5,0,0,0,2.5,2.5H20a.25.25,0,0,1,.25.25v6a.25.25,0,0,0,.25.25H22a1.255,1.255,0,0,1,1.248,1.256,1.231,1.231,0,0,1-.474.973l-9.983,7.986A1.227,1.227,0,0,1,11.223,23.6Z', 'M16.5,5.873a1.5,1.5,0,0,1-1.5-1.5V.971A.251.251,0,0,1,15.438.8l4.237,4.649a.251.251,0,0,1-.184.419Z']],
  NavigationUp1: ['navigation-up-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.382,9.744,13.919,3.162a3.371,3.371,0,0,0-3.838,0L.618,9.744a1.44,1.44,0,0,0,1.644,2.365l9.464-6.584a.482.482,0,0,1,.548,0l9.464,6.583a1.44,1.44,0,0,0,1.644-2.365Z', 'M1.988,21.261l9.464-6.584a.964.964,0,0,1,1.1,0l9.464,6.584a.958.958,0,0,0,.548.172.944.944,0,0,0,.444-.11.959.959,0,0,0,.516-.85V17.258a.961.961,0,0,0-.412-.788L13.644,9.887a2.892,2.892,0,0,0-3.289,0L.892,16.47a.961.961,0,0,0-.412.788v3.215a.961.961,0,0,0,1.508.788Z']],
  NavigationArrowsLeft: ['navigation-arrows-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.913,21.706v-1.4a.5.5,0,0,0-.13-.336L4.45,13.006a1.492,1.492,0,0,1,0-2.018l6.333-6.965a.5.5,0,0,0,.13-.337v-1.4A1,1,0,0,0,9.172,1.62L.359,11.313a.983.983,0,0,0-.272.679,1.017,1.017,0,0,0,.265.681l8.814,9.692a.968.968,0,0,0,1.1.27A.992.992,0,0,0,10.913,21.706Z', 'M6.859,11.313a.983.983,0,0,0-.272.679,1.017,1.017,0,0,0,.265.681l8.814,9.692a.968.968,0,0,0,1.1.27.992.992,0,0,0,.649-.929v-1.4a.5.5,0,0,0-.13-.336L10.95,13.006a1.492,1.492,0,0,1,0-2.018l6.333-6.965a.5.5,0,0,0,.13-.337v-1.4a1,1,0,0,0-1.741-.666Z', 'M13.348,11.322a1,1,0,0,0,0,1.346l8.823,9.707a1,1,0,0,0,1.741-.673V2.289a1,1,0,0,0-1.74-.672Z']],
  NavigationArrowsUp: ['navigation-arrows-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.291,10.91h1.4a.5.5,0,0,0,.337-.13l6.964-6.333a1.494,1.494,0,0,1,2.018,0l6.965,6.333a.5.5,0,0,0,.336.13h1.4a.986.986,0,0,0,.921-.626.975.975,0,0,0-.254-1.114L12.685.357a.987.987,0,0,0-.679-.272,1.015,1.015,0,0,0-.681.265L1.633,9.163a.971.971,0,0,0-.271,1.1A.994.994,0,0,0,2.291,10.91Z', 'M12.685,6.857a.987.987,0,0,0-.679-.272,1.015,1.015,0,0,0-.681.265L1.633,15.663a.971.971,0,0,0-.271,1.1.994.994,0,0,0,.929.648h1.4a.5.5,0,0,0,.337-.13l6.964-6.333a1.494,1.494,0,0,1,2.018,0l6.965,6.333a.5.5,0,0,0,.336.13h1.4a.986.986,0,0,0,.921-.626.975.975,0,0,0-.254-1.114Z', 'M12.675,13.346a1,1,0,0,0-1.345,0L1.623,22.17A1,1,0,0,0,2.3,23.91H21.708a1,1,0,0,0,.673-1.739Z']]
};
exports["default"] = _default;